module.exports = __webpack_public_path__ + "img/b_12.77f342f1.jpg";